import { useSelector } from 'react-redux';

import { User } from '@gravity-ui/uikit';

import type { AppState } from 'store/store';

import { NavLink } from 'react-router-dom';

import styles from './styles.module.scss';

export const ProfileIcon = () => {
	const user = useSelector((state: AppState) => state.userState.user);
	return (
		<div>
			{user?.imageUrl ? (
				<NavLink to="/profile">
					{({ isActive }) => (
						<User
							avatar={{
								imgUrl: `${user?.firstName} ${user?.lastName}`,
								fallbackImgUrl: user?.imageUrl,
							}}
							size="m"
							className={styles.user_icon}
						/>
					)}
				</NavLink>
			) : (
				<NavLink to="/profile">
					{({ isActive }) => (
						<User
							avatar={{
								text: `${user?.firstName} ${user?.lastName}`,
								theme: 'brand',
								backgroundColor: '#ffbe5c',
							}}
							size="m"
							className={styles.user_icon}
						/>
					)}
				</NavLink>
			)}
		</div>
	);
};
